import React from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAppState } from 'state';

import useConfig from 'app/config';
import { routes } from 'app/routes/constants';

export const SigninRoute = () => {
  const navigate = useNavigate();
  const { config } = useConfig();

  const signedIn = useAppState(({ auth }) => auth.signedIn);
  const ssoEnabled = config.REACT_APP_SSO_ENABLED;

  if (signedIn) {
    navigate(routes.HOME);
  } else {
    const redirectTo = `${window.location.origin}/portal-authorization`;
    const redirectUrl = `${config.REACT_APP_SSO_REDIRECT_URL}?redirect_to=${redirectTo}`;

    if (ssoEnabled) {
      window.location.replace(redirectUrl);
    }
  }

  return <Outlet />;
};
